import { ValueGetterParamsDealVersion } from './value-getters.interface';
import { isDefined } from '../../../utils/utils';
import { OrderPeriodType } from '../../../types/deal.types';

export function ropValueGetter({ data }: ValueGetterParamsDealVersion): string {
  if (!isDefined(data.orderPeriod)) {
    return '';
  }

  switch (data.orderPeriod?.type) {
    case OrderPeriodType.all:
    case OrderPeriodType.retail:
      return data.orderPeriod?.beginDate
        ? data.orderPeriod?.beginDate.format('MM/DD/YYYY')
        : '';

    case OrderPeriodType.institutional:
      return '';

    default:
      return '';
  }
}
